import { CustomerCompanyMessage } from './CustomerCompanyMessage';
import { Iso8601DateTimeString } from './Iso8601DateTimeString';
import { PaymentTermReference } from './PaymentTermReference';
import { SupplierCompanyMessage } from './SupplierCompanyMessage';
import { UserMessage } from './UserMessage';
import { VesselMessage } from './VesselMessage';

export enum PriceListActivationMode {
    MANUAL = 'MANUAL',
    AUTO = 'AUTO',
}

export enum EffectiveDateMode {
    ORDER_DATE = 'ORDER_DATE',
    DELIVERY_DATE = 'DELIVERY_DATE',
}

export interface ContractPriceListRequestMessage {
    originalFileId: string;
    validFrom?: string;
    validUntil?: string;
    activeOnApproval: boolean;
}

export interface ContractPriceListResponseMessage {
    id: string;
    dateCreated?: Iso8601DateTimeString;
    dateUpdated?: Iso8601DateTimeString;
    createdBy?: string;
    updatedBy?: string;
    contractId: string;
    originalFileId: string;
    validFrom: string;
    validUntil?: string;
    status?: string;
    activeOnApproval?: boolean;
    fileName?: string;
}

export enum ContractState {
    DRAFT = 'DRAFT',
    AWARDED = 'AWARDED',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum ContractPriceListStatus {
    PROCESSING = 'PROCESSING',
    AWARDED = 'AWARDED',
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
}

export interface ContractPriceListMessage {
    id: string;
    dateCreated?: Iso8601DateTimeString;
    dateUpdated?: Iso8601DateTimeString;
    createdBy?: string;
    updatedBy?: string;
    contractId: string;
    originalFileId: string;
    normalizedFileId?: string;
    validFrom: Iso8601DateTimeString;
    validUntil?: Iso8601DateTimeString;
    status: ContractPriceListStatus;
    activeOnApproval: boolean;
    fileName?: string;
}

export interface ContractMessage {
    id: string;
    dateCreated?: Iso8601DateTimeString;
    dateUpdated?: Iso8601DateTimeString;
    createdBy?: string;
    updatedBy?: string;
    createdByUser?: UserMessage;
    updatedByUser?: UserMessage;
    supplierGroupId?: string;
    supplierId?: string;
    customerGroupId?: string;
    customerIds: string[];
    excludedVesselIds?: string[];
    state: ContractState;
    name: string;
    contractReference?: string;
    description?: string;
    minimumVolume?: number;
    validFrom?: Iso8601DateTimeString;
    validUntil?: Iso8601DateTimeString;
    evergreen: boolean;
    paymentTermReference?: PaymentTermReference;
    paymentTermReferenceDays?: number;
    gtc?: string;
    priceListActivationMode?: PriceListActivationMode;
    effectiveDateMode?: EffectiveDateMode;
    supplier?: SupplierCompanyMessage;
    customers: CustomerCompanyMessage[];
    excludedVessels?: VesselMessage[];
    priceLists: ContractPriceListMessage[];
}
